<template>
  <a-drawer
    :title="title"
    :maskClosable="false"
    :width="drawerWidth"
    placement="right"
    :closable="true"
    @close="handleCancel"
    :visible="visible"
    style="height: 100%;overflow: auto;padding-bottom: 53px;">

    <template slot="title">
      <div style="width: 100%;">
        <span>{{ title }}</span>
        <span style="display:inline-block;width:calc(100% - 51px);padding-right:10px;text-align: right">
          <a-button @click="toggleScreen" icon="appstore" style="height:20px;width:20px;border:0px"></a-button>
        </span>
      </div>

    </template>

    <a-spin :spinning="confirmLoading">
      <a-form-model ref="form" :model="model" :rules="validatorRules">

        <!--<a-form-model-item label="用户账号" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="username">
          <a-input placeholder="请输入用户账号" v-model="model.username" :readOnly="!!model.id"/>
        </a-form-model-item>-->

        <a-form-model-item :label="language['column.jobNumber']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="workNo">
          <a-input :placeholder="language['warning.jobNumberRequired']" v-model="model.workNo" :readOnly="!!model.id" :maxLength="maxLength.workNo"/>
        </a-form-model-item>

        <a-form-model-item :label="language['user.column.userName']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="realname">
          <a-input :placeholder="language['user.pleaseSetRealname']" v-model="model.realname" :maxLength="maxLength.realname"/>
        </a-form-model-item>
        <a-form-model-item :label="language['employee.column.englishName']" :labelCol="labelCol" :wrapperCol="wrapperCol" >
          <a-input  v-model="model.englishName" :placeholder="language['common.pleaseInput']+language['employee.column.englishName']" :maxLength="40"/>
        </a-form-model-item>

        <!--机构组织-->
        <a-form-model-item :label="language['PlatForm.employee.columns.depart']" :labelCol="labelCol" :wrapperCol="wrapperCol" v-if="model.isUser==='1'">
          <!--<j-select-depart v-model="model.orgId" :multi="false" @back="backDepartInfo" :backDepart="true" :treeOpera="true">></j-select-depart>-->
          <div><a-button @click="toSelectDeport" type="primary" icon="search">{{language['PlatForm.employee.chooseDepart']}}</a-button></div>
          <div v-for="(item,index) in selectedApps" :key="index" :value="item" v-if="!boo && item.selectedDepartNames">

            <span style="font-weight: 900;">{{item.applicationName}}</span> : {{item.selectedDepartNames}}
            <!--<a-icon  slot="suffix" type="close-circle" @click="handleEmpty" title="清空"/>-->

          </div>
          <div v-for="(item,index) in newselectedApps" :key="index" :value="item" v-if="boo && item.selectedDepartNames">
            <span style="font-weight: 900;">{{item.applicationName}}</span> : {{item.selectedDepartNames}}
          </div>
        </a-form-model-item>

        <a-form-model-item :label="language['user.column.Avatar']" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-image-upload class="avatar-uploader" :text="language['common.uploadButton']" v-model="model.avatar" ></j-image-upload>
        </a-form-model-item>

        <a-form-model-item :label="language['column.gender']" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-select  v-model="model.sex"  :placeholder="language['warning.genderRequired']" :getPopupContainer= "(target) => target.parentNode">
            <a-select-option :value="1">{{language['common.sex.man']}}</a-select-option>
            <a-select-option :value="2">{{language['common.sex.woman']}}</a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item :label="language['user.column.birthday']" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-date-picker
            style="width: 100%"
            :placeholder="language['warning.birthdayRequired']"
            v-model="model.birthday"
            :format="dateFormat"
            :getCalendarContainer="node => node.parentNode"/>
        </a-form-model-item>

        <a-form-model-item :label="language['column.mailbox']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="email">
          <a-input :placeholder="language['warning.emailRequired']" v-model="model.email" :maxLength="60"/>
        </a-form-model-item>

        <a-form-model-item :label="language['column.cellphoneNumber']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="phone">
          <a-input :placeholder="language['warning.phoneNumberIncorrect']" v-model="model.phone"  :maxLength="20"/>
        </a-form-model-item>

        <a-form-model-item :label="language['column.Landline']" :labelCol="labelCol" :wrapperCol="wrapperCol" >
          <a-input :placeholder="language['warning.landlineNumberRequired']" v-model="model.telephone" :maxLength="20"/>
        </a-form-model-item>

        <a-form-model-item :label="language['PlatForm.employee.columns.position']" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-select-position :placeholder="language['PlatForm.employee.pleaseSetPosition']" :multiple="false" v-model="model.post"/>
        </a-form-model-item>

        <a-form-model-item :label="language['PlatForm.employee.columns.joinDate']" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-date-picker
            style="width: 100%"
            v-model="model.joinDate"
            :format="dateFormat"
            :getCalendarContainer="node => node.parentNode"/>
        </a-form-model-item>


        <a-form-model-item :label="language['PlatForm.employee.columns.joinBgDate']" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-date-picker
            style="width: 100%"
            v-model="model.joinBgDate"
            :format="dateFormat"
            :getCalendarContainer="node => node.parentNode"/>
        </a-form-model-item>

        <a-form-model-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="language['PlatForm.employee.columns.isResigned']">
          <a-switch :checkedChildren="language['common.yes']" :unCheckedChildren="language['common.no']" v-model="model.isResigned!=0" @change='resignedChange'/>
        </a-form-model-item>

        <a-form-model-item :label="language['PlatForm.employee.columns.siteCode']" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <!--<a-input placeholder="请输入工作地点" v-model="model.siteCode" />-->
          <j-dict-select-tag  v-model="model.siteCode" :placeholder="language['PlatForm.employee.pleaseSetWorkplace']"
                              dictCode="	work_place"/>
        </a-form-model-item>

        <a-form-model-item :label="language['PlatForm.employee.columns.educationDegree']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="educationDegree">
          <!--<a-input placeholder="请输入教育程度" v-model="model.educationDegree" />
          <j-dict-select-tag></j-dict-select-tag>-->
          <j-dict-select-tag  v-model="model.educationDegree" :placeholder="language['PlatForm.employee.pleaseSetEducationDegree']"
                              dictCode="education_degree"/>
        </a-form-model-item>

        <a-form-model-item :label="language['PlatForm.employee.columns.nationality']" :labelCol="labelCol" :wrapperCol="wrapperCol" >
          <!--<a-input placeholder="请输入国籍" v-model="model.nationality" />-->
              <a-select
                style="width: 100%"
                @change="nationalityChange"
                v-model="model.nationality">
                <a-select-option v-for="(item,index) in nationalityRegionList" :key="index.toString()" :value="item.id.toString()">
                  {{ item.name }}
                </a-select-option>
              </a-select>
        </a-form-model-item>

        <a-form-model-item :label="language['PlatForm.employee.columns.province']" :labelCol="labelCol" :wrapperCol="wrapperCol" >
          <!--<a-input placeholder="请输入工作地点" v-model="model.province" />-->
          <a-select
            style="width: 100%"
            @change="provinceChange"
            v-model="model.province">
            <a-select-option v-for="(item,index) in provinceRegionList" :key="index.toString()" :value="item.id.toString()">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item :label="language['PlatForm.employee.columns.county']" :labelCol="labelCol" :wrapperCol="wrapperCol" >
          <!--<a-input placeholder="县/区" v-model="model.county" />-->
          <a-select
            style="width: 100%"
            v-model="model.county">
            <a-select-option v-for="(item,index) in countyRegionList" :key="index.toString()" :value="item.id.toString()">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item :label="language['PlatForm.employee.columns.address']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="address">
          <a-input :placeholder="language['PlatForm.employee.pleaseSetAddress']" v-model="model.address" :maxLength="maxLength.address" style="width: 80%"/>
          <a-button @click="languageModelOpen('SysBmEmployee','address',addressLanguages,)" type="primary"  style="left: 5%" >{{language['common.language']}}</a-button>
        </a-form-model-item>

        <!--<a-form-model-item label="资料来源" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="fromSource">
          <a-input placeholder="请输入资料来源" v-model="model.fromSource" />
        </a-form-model-item>-->

        <a-form-model-item :label="language['basedata.remark']" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input  v-model="model.remark" :maxLength="maxLength.remark"/>
        </a-form-model-item>

        <a-form-model-item :label="language['PlatForm.employee.columns.costCode']" :labelCol="labelCol" :wrapperCol="wrapperCol"   style="margin-bottom: 30px">
          <a-input  v-model="model.costCode"  :disabled="true"/>
        </a-form-model-item>
        <a-form-model-item :label="language['PlatForm.employee.columns.factoryName']" :labelCol="labelCol" :wrapperCol="wrapperCol"   style="margin-bottom: 30px">
          <a-input  v-model="model.factoryName"  :disabled="true"/>
        </a-form-model-item>
        <a-form-model-item :label="language['PlatForm.employee.columns.empClass']" :labelCol="labelCol" :wrapperCol="wrapperCol"   style="margin-bottom: 30px">
          <a-input  v-model="model.empClass"  :disabled="true"/>
        </a-form-model-item>
        <a-form-model-item :label="language['PlatForm.employee.columns.companyName']" :labelCol="labelCol" :wrapperCol="wrapperCol"   style="margin-bottom: 30px">
          <a-input  v-model="model.companyName"  :disabled="true"/>
        </a-form-model-item>
        <a-col :span="24">
          <a-form-model-item :label="language['PlatForm.employee.columns.selectedAppids']" :labelCol="labelCol" :wrapperCol="wrapperCol" v-if="model.isUser==='1'">
            <j-multi-select-tag
              v-model="model.selectedAppids"
              :options="appsOptions"
              :disabled="true"
            >
            </j-multi-select-tag>
          </a-form-model-item>
        </a-col>

        <!--部门分配-->
        <!--<a-form-model-item label="部门分配" :labelCol="labelCol" :wrapperCol="wrapperCol" v-show="!departDisabled">
          <j-select-depart v-model="model.selecteddeparts" :multi="true" @back="backDepartInfo" :backDepart="true" :treeOpera="true">></j-select-depart>
        </a-form-model-item>-->



        <a-col :span="24" style="height: 50px"></a-col>
      </a-form-model>
      <language-model ref="languageModel" @ok="languageOk"></language-model>
    </a-spin>


    <div class="drawer-bootom-button" v-show="!disableSubmit">
      <a-popconfirm :title="language['message.giveUpEditing']" @confirm="handleCancel" :okText="language['common.determineButton']" :cancelText="language['common.cancel']">
        <a-button style="margin-right: .8rem">{{language['common.cancel']}}</a-button>
      </a-popconfirm>
      <a-button @click="handleSubmit" type="primary" :loading="confirmLoading">{{language['common.submitButton']}}</a-button>
    </div>
    <j-select-depart-modal-by-application ref="departSelectModalByApplication" @ok="loadselectDeport"></j-select-depart-modal-by-application>
  </a-drawer>
</template>

<script>
  import moment from 'moment'
  import Vue from 'vue'
  import { ACCESS_TOKEN } from "@/store/mutation-types"
  import { getAction,putAction,postAction } from '@/api/manage'
  import { addUser,editUser,queryUserRole,queryall } from '@/api/api'
  import { disabledAuthFilter } from "@/utils/authFilter"
  import { duplicateCheck } from '@/api/api'
  import LanguageModel from "@/components/LanguageModel"

  import JSelectDepartModalByApplication from "../../../components/jeecgbiz/modal/JSelectDepartModalByApplication";

  export default {
    name: "SysBmEmployeeModal",
    components: {
      JSelectDepartModalByApplication,
      LanguageModel,
    },
    data () {
      return {
        departDisabled: false, //是否是我的部门调用该页面
        roleDisabled: false, //是否是角色维护调用该页面
        modalWidth:800,
        drawerWidth:700,
        modaltoggleFlag:true,
        confirmDirty: false,
        userId:"", //保存用户id
        disableSubmit:false,
        dateFormat:"YYYY-MM-DD",
        maxLength:{
          realname:40,
          workNo:40,
          remark:200,
          address:100,
        },
        validatorRules:{
          username:[{required: true, message: this.$store.getters.language['warning.userAccountRequired']},
                    {validator: this.validateUsername,}],
          password: [{required: true,pattern:/^(?=.*[a-zA-Z])(?=.*\d)(?=.*[~!@#$%^&*()_+`\-={}:";'<>?,./]).{8,}$/,message: this.$store.getters.language['warning.passwordConsists']},
                     {validator: this.validateToNextPassword,trigger: 'change'}],
          orgId:[{required: true, message: this.$store.getters.language['PlatForm.employee.pleaseSetDepart']}],
          post:[{required: true, message: this.$store.getters.language['PlatForm.employee.pleaseSetPosition']}],
          confirmpassword: [{required: true, message: '请重新输入登录密码!',},
                            { validator: this.compareToFirstPassword,}],
          realname:[{ required: true, message: this.$store.getters.language['user.pleaseSetRealname'] }],
          phone: [{required: true, message: this.$store.getters.language['warning.phoneRequired']}, {validator: this.validatePhone}],
          email: [{required: true, message: this.$store.getters.language['warning.emailRequired']},{validator: this.validateEmail}],
          roles:{},
          workNo:[ { required: true, message: this.$store.getters.language['warning.jobNumberRequired'] },
                  { validator: this.validateWorkNo }],
          telephone: [{ pattern: /^0\d{2,3}-[1-9]\d{6,7}$/, message: this.$store.getters.language['warning.landlineNumberFormatIncorrect'] },]
        },
        departList:[],
        nationalityRegionList:[],
        provinceRegionList:[],
        countyRegionList:[],
        departIdShow:false,
        title:"",
        visible: false,
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        uploadLoading:false,
        confirmLoading: false,
        headers:{},
        url: {
          fileUpload: window._CONFIG['domianURL']+"/sys/common/upload",
          userWithDepart: "/sys/employee/userDepartList", // 引入为指定用户查看部门信息需要的url
          userId:"/sys/employee/generateUserId", // 引入生成添加用户情况下的url
          syncUserByUserName:"/act/process/extActProcess/doSyncUserByUserName",//同步用户到工作流
          queryTenantList: '/sys/tenant/queryList'
        },
        tenantsOptions: [],
        rolesOptions:[],
        nextDepartOptions:[],
        appsOptions:[],


        selectedApps:[],
        newselectedApps:[],
        userDepartWithApplication:[],
        boo:false,

        addressLanguages:[],
      }
    },
    created () {
      const token = Vue.ls.get(ACCESS_TOKEN);
      this.headers = {"X-Access-Token":token}
      this.initRoleList()
      this.initTenantList()
      this.initAppList();
    },
    computed:{
      uploadAction:function () {
        return this.url.fileUpload;
      },
      language() {
        return this.$store.getters.language
      },
    },
    methods: {
      resignedChange(value){
        if(value){
          this.model.isResigned='1'
        }else{
          this.model.isResigned='0'
        }
      },
      languageModelOpen(dataTable,dataColumn,languagelist){
        this.$refs.languageModel.edit("platform",dataTable,dataColumn,this.model.id,languagelist);
      },
      languageOk(map){
        if(map&&map.dataColumn == 'address'){
          this.addressLanguages = map.languagelist;
        }
      },
      toSelectDeport(){
        let data1 = this.selectedApps
        let data2 = this.userDepartWithApplication
        this.$refs.departSelectModalByApplication.show(data1,data2)
        // this.$refs.departModalBySingleapplication.loadTree("env_audit","f3a61524d6ee459cb8c7dbfb820b0643")
      },
      loadselectDeport(data,rows){
        this.boo = true;
        let that = this;
        that.newselectedApps =[];
        for(let i=0;i<that.selectedApps.length;i++){
          for(let j=0;j<data.length;j++){
            if(data[j].applicationId==that.selectedApps[i].id){
              that.selectedApps[i].selectedDepartNames = data[j].selectedDepartNames
              break;
            }
          }
        }
        that.selectedApps.forEach(item=>{
          this.newselectedApps.push(item)
        })
        this.userDepartWithApplication = data
      },
      getUserApplications(userId){
        let params = {
          id: userId,
        };
        getAction("/sys/user/getUserApplications", params).then((res)=>{
          if (res.success) {
            let list = res.result;
            let ids = "";
            if(list){
              list.forEach(item=>{
                if(ids == ""){
                  ids = item.id;
                }else{
                  ids = ids+","+item.id;
                }
              })
            }
            // this.selectedApps = list;
            this.model.selectedAppids = ids;
            console.log('that.model.selectedApps=',this.selectedApps)
            this.getUserDepartsWithApplication(userId,ids.split(","),list);
          }
        })
      },
      //初始化应用list
      getUserDepartsWithApplication(userid,applicationIds,applicaitonList){
        // getUserDeparts(userid,applicationIds,applicaitonList){
          this.userDepartWithApplication = [];
          let that = this;
          getAction("/sys/user/userDepartList",{userId:userid}).then((res)=>{
            if(res.success){
              applicationIds.forEach(id=>{
                let map={};
                let selectDepart=[]
                let selectDepartNames = "";
                for (let i = 0; i < res.result.length; i++) {
                  let value = res.result[i];
                  if(value.applicationId == id){
                    selectDepart.push(value.key);
                    if(selectDepartNames == ""){
                      selectDepartNames = value.title;
                    }else{
                      selectDepartNames = selectDepartNames+"\u00A0 |\u00A0 "+value.title;
                    }
                  }
                }
                map.applicationId = id;
                map.selectedDeparts = selectDepart;
                map.selectedDepartNames = selectDepartNames;
                this.userDepartWithApplication.push(map);
                if(applicaitonList.length>0){
                  applicaitonList.forEach(item=>{
                    if(item.id == id)item.selectedDepartNames = selectDepartNames
                  })
                }
                this.selectedApps = applicaitonList;
              })
            }
          })
      },
      //初始化应用list
      initAppList(){
        getAction("/sys/portal/sysPortalOrg/getAllApps").then((res)=>{
          if(res.success){
            this.appsOptions = res.result.map((item,index,arr)=>{
              let c = {label:item.applicationName, value:item.id}
              return c;
            })
            console.log('this.appsOptions: ',this.appsOptions)
          }
        })
      },
      initDepartList(){
        this.departList = [];
        getAction("/sys/permission/queryTreeList").then((res)=>{
          if(res.success){
            console.log(res)
            that.treeData = [];
            let treeList = res.result.treeList
            for(let a=0;a<treeList.length;a++){
              let temp = treeList[a];
              temp.isLeaf = temp.leaf;
              that.treeData.push(temp);
            }
          }
        });
      },
      add () {
        this.refresh();
        this.edit({activitiSync:'1',userIdentity:1});
      },
      edit (record) {
        this.boo = false;
        let that = this;
        that.visible = true;
        //根据屏幕宽度自适应抽屉宽度
        this.resetScreenSize();
        that.userId = record.id;
        that.model = Object.assign({},{selectedroles:'',selecteddeparts:''}, record);
        //身份为上级显示负责部门，否则不显示
        if(this.model.userIdentity==2){
          this.departIdShow=true;
        }else{
          this.departIdShow=false;
        }

        if(record.hasOwnProperty("id")&&record.isUser==='1'){
          // that.getUserRoles(record.id);
          // that.getUserDeparts(record.id);
          this.getUserApplications(record.id);
        }
        this.initNationalityList();
        this.initProvinceList(this.model.nationality);
        this.initCountyList(this.model.province);
        this.initLanguagetemp('SysBmEmployee','address',this.model.id);
      },
      initLanguagetemp(dataTable,dataColumn,dataId){
        getAction("/sys/syslanguagedata/querylistby", {applicationCode:"platform",dataTable:dataTable,dataColumn:dataColumn,dataId:dataId}).then((res)=> {
          if (res.success) {
            this.addressLanguages = res.result;
          }
        })
      },
      isDisabledAuth(code){
        return disabledAuthFilter(code);
      },
      //窗口最大化切换
      toggleScreen(){
        if(this.modaltoggleFlag){
          this.modalWidth = window.innerWidth;
        }else{
          this.modalWidth = 800;
        }
        this.modaltoggleFlag = !this.modaltoggleFlag;
      },
      // 根据屏幕变化,设置抽屉尺寸
      resetScreenSize(){
        let screenWidth = document.body.clientWidth;
        if(screenWidth < 500){
          this.drawerWidth = screenWidth;
        }else{
          this.drawerWidth = 700;
        }
      },
      //初始化租户字典
      initTenantList(){
        getAction(this.url.queryTenantList).then(res=>{
          if(res.success){
            this.tenantsOptions = res.result.map((item,index,arr)=>{
              let c = {label:item.name, value: item.id+""}
              return c;
            })
          }
        })
      },
      //初始化角色字典
      initRoleList(){
        queryall().then((res)=>{
          if(res.success){
            this.rolesOptions = res.result.map((item,index,arr)=>{
              let c = {label:item.roleName, value:item.id}
              return c;
            })
            console.log('this.rolesOptions: ',this.rolesOptions)
          }
        });
      },
      getUserRoles(userid){
        queryUserRole({userid:userid}).then((res)=>{
          if(res.success){
            this.model.selectedroles = res.result.join(",");
            console.log('that.model.selectedroles=',this.model.selectedroles)
          }
        });
      },
      getUserDeparts(employeeId){
        let that = this;
        getAction(that.url.userWithDepart,{userId:employeeId}).then((res)=>{
          if(res.success){
            let departOptions=[];
            let selectDepartKeys=[]
            for (let i = 0; i < res.result.length; i++) {
              selectDepartKeys.push(res.result[i].key);
              //新增负责部门选择下拉框
              departOptions.push({
                value: res.result[i].key,
                label: res.result[i].title
              })
            }
            that.model.selecteddeparts = selectDepartKeys.join(",")
            that.nextDepartOptions=departOptions;
            console.log('that.nextDepartOptions=',that.nextDepartOptions)
          }
        })
      },
      backDepartInfo(info) {
        this.model.departIds = this.model.selecteddeparts;
        this.nextDepartOptions = info.map((item,index,arr)=>{
          let c = {label:item.text, value: item.value+""}
          return c;
        })
      },
      refresh () {
        this.userId=""
        this.nextDepartOptions=[];
        this.departIdShow=false;
      },
      close () {
        this.$emit('close');
        this.visible = false;
        this.disableSubmit = false;
        this.nextDepartOptions=[];
        this.departIdShow=false;
        this.$refs.form.resetFields();
      },
      moment,
      handleSubmit () {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            //如果是上级择传入departIds,否则为空
            if(this.model.userIdentity!==2){
              this.model.departIds="";
            }
            this.model.fromSource = "platform";
            let obj;
            if(!this.model.id){
              obj=putAction("/sys/employee/add",this.model)
            }else{
              obj=putAction("/sys/employee/edit",this.model)
            }
            obj.then((res)=>{
              if(res.success){
                if(this.model.isUser==='1'){
                  let map = {};
                  map.data=this.userDepartWithApplication
                  map.userId = this.userId
                  putAction("/sys/UserDepart/addList", map).then((res)=> {
                    if (res.success) {
                      this.addressLanguages.forEach(item=>{
                        if(!item.dataId){
                          item.dataId = this.userId;
                        }
                      })
                      postAction("/sys/syslanguagedata/saveSysLanguageDataList",this.addressLanguages).then((res)=>{
                        if(res.success){
                          that.$message.success(res.message);
                          that.$emit('ok');
                        }
                      })
                    }
                  })
                }else{
                  postAction("/sys/syslanguagedata/saveSysLanguageDataList",this.addressLanguages).then((res)=>{
                    if(res.success){
                      that.$message.success(res.message);
                      that.$emit('ok');
                    }
                  })
                  // that.$message.success(res.message);
                  // that.$emit('ok');
                }

              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          }else{
            return false;
          }
        })
      },
      handleCancel () {
        this.close()
      },
      validateToNextPassword (rule, value, callback) {
        const confirmpassword=this.model.confirmpassword;
        if (value && confirmpassword && value !== confirmpassword) {
          callback(this.language['warning.passwordEnteredTwiceDifferent']);
        }
        if (value && this.confirmDirty) {
          this.$refs.form.validateField(['confirmpassword']);
        }
        callback();
      },
      compareToFirstPassword (rule, value, callback) {
        if (value && value !== this.model.password) {
          callback(this.language['warning.passwordEnteredTwiceDifferent']);
        } else {
          callback()
        }
      },
      validatePhone(rule, value, callback){
        if(!value){
          callback()
        }else{
        //  if(new RegExp(/^1[3|4|5|7|8|9][0-9]\d{8}$/).test(value)){
            var params1 = {
              tableName: 'sys_user',
              fieldName: 'phone',
              fieldVal: value,
              dataId: this.userId,
              delFlag:'0'
            };
            duplicateCheck(params1).then((res) => {
              if (res.success) {
                var params2 = {
                  tableName: 'sys_bm_employee',
                  fieldName: 'phone',
                  fieldVal: value,
                  dataId: this.userId,
                  delFlag:'0'
                };
                duplicateCheck(params2).then((res) => {
                  if (res.success) {
                    callback()
                  } else {
                    callback(this.language['warning.existPhone'])
                  }
                })
              } else {
                callback(this.language['warning.existPhone'])
              }
            })

          // }else{
          //   callback("请输入正确格式的手机号码!");
          // }
        }
      },
      validateEmail(rule, value, callback){
        if(!value){
          callback()
        }else{
          if(new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/).test(value)){
            //2022/3/10 不校验邮箱唯一性，公司内部存在共用邮箱的情况
            callback();
            /*var params1 = {
              tableName: 'sys_user',
              fieldName: 'email',
              fieldVal: value,
              dataId: this.userId
            };
            duplicateCheck(params1).then((res) => {
              console.log(res)
              if (res.success) {
                var params2 = {
                  tableName: 'sys_bm_employee',
                  fieldName: 'email',
                  fieldVal: value,
                  dataId: this.userId
                };
                duplicateCheck(params2).then((res) => {
                  console.log(res)
                  if (res.success) {
                    callback()
                  } else {
                    callback("邮箱已存在员工!")
                  }
                })
              } else {
                callback("邮箱已存在于用户!")
              }
            })*/

          }else{
            callback(this.language['warning.emailFormatIncorrect'])
          }
        }
      },
      validateUsername(rule, value, callback){
        var params = {
          tableName: 'sys_user',
          fieldName: 'work_no',
          fieldVal: value,
          dataId: this.model.id,
          delFlag:'0'
        };
        duplicateCheck(params).then((res) => {
          if (res.success) {
          callback()
        } else {
          callback(this.language["warning.usernameAlreadyExists"])
        }
      })
      },
      validateWorkNo(rule, value, callback){
        var params = {
          tableName: 'sys_bm_employee',
          fieldName: 'work_no',
          fieldVal: value,
          dataId: this.model.id,
          delFlag:'0'
        };
        duplicateCheck(params).then((res) => {
          if (res.success) {
            var map = {
              tableName: 'sys_user',
              fieldName: 'work_no',
              fieldVal: value,
              dataId: this.model.id,
              delFlag:'0'
            };
            duplicateCheck(map).then((res) => {
              if (res.success) {
                callback()
                // this.validateUsername(rule,value,callback);
              } else {
                callback(this.language["warning.jobNumberAlreadyExists"])
              }
            })
          } else {
            callback(this.language["warning.jobNumberAlreadyExists"])
          }
        })
      },
      handleConfirmBlur(e) {
        const value = e.target.value;
        this.confirmDirty = this.confirmDirty || !!value
      },
      beforeUpload: function(file){
        var fileType = file.type;
        if(fileType.indexOf('image')<0){
          this.$message.warning(this.language['warning.pleaseUploadImage']);
          return false;
        }
        //TODO 验证文件大小
      },
      identityChange(e){
        if(e.target.value===1){
            this.departIdShow=false;
        }else{
            this.departIdShow=true;
        }
      },
      nationalityChange(){
        this.initProvinceList(this.model.nationality)
        this.initCountyList('');
      },
      provinceChange(){
        this.initCountyList(this.model.province);
      },
      initNationalityList() {
        getAction('/sys/region/getListByParentId', {"parentId": 0}).then((res) => {
          if (res.success) {
            this.nationalityRegionList = res.result;
          } else {
            console.log(res.message);
          }
        });
      },
      initProvinceList(parentId) {
        if(parentId === null || parentId === ''){
          this.provinceRegionList = [];
          return;
        }
        getAction('/sys/region/getListByParentId', {"parentId": parentId}).then((res) => {
          if (res.success) {
            this.provinceRegionList = res.result;
          } else {
            console.log(res.message);
          }
        });
      },
      initCountyList(parentId) {
        if(parentId === null || parentId === ''){
          this.countyRegionList = [];
          return;
        }
        getAction('/sys/region/getListByParentId', {"parentId": parentId}).then((res) => {
          if (res.success) {
            this.countyRegionList = res.result;
          } else {
            console.log(res.message);
          }
        });
      },
    }
  }
</script>

<style scoped>
  .avatar-uploader > .ant-upload {
    width:104px;
    height:104px;
  }
  .ant-upload-select-picture-card i {
    font-size: 49px;
    color: #999;
  }

  .ant-upload-select-picture-card .ant-upload-text {
    margin-top: 8px;
    color: #666;
  }

  .ant-table-tbody .ant-table-row td{
    padding-top:10px;
    padding-bottom:10px;
  }

  .drawer-bootom-button {
    position: absolute;
    bottom: -8px;
    width: 100%;
    border-top: 1px solid #e8e8e8;
    padding: 10px 16px;
    text-align: right;
    left: 0;
    background: #fff;
    border-radius: 0 0 2px 2px;
  }
</style>